// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Alert } from '@metarouter-private/mr-mui';

import FileUploadButton from '../components/FileUploadButton';

export default function BulkOperationFileSelector({
  description,
  selectedFile,
  itemCount,
  itemLabel,
  onFileSelect,
  hasError,
  errorMessage,
  testId,
}) {
  return (
    <Stack spacing={3}>
      <Typography variant="body1">{description}</Typography>

      <FileUploadButton
        accept=".yaml,.yml"
        onChange={onFileSelect}
        helperText="Select a YAML file (.yaml or .yml)"
        testId={testId}
      />

      {selectedFile && !hasError && itemCount > 0 && (
        <Alert severity="info">
          <Typography variant="body2">
            <strong>File selected:</strong> {selectedFile.name}
          </Typography>
          <Typography variant="body2">
            <strong>{itemLabel} detected:</strong> {itemCount}
          </Typography>
        </Alert>
      )}

      {hasError && (
        <Alert severity="error">
          <Typography variant="body2">{errorMessage}</Typography>
        </Alert>
      )}
    </Stack>
  );
}

BulkOperationFileSelector.propTypes = {
  description: PropTypes.string.isRequired,
  selectedFile: PropTypes.object,
  itemCount: PropTypes.number.isRequired,
  itemLabel: PropTypes.string.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  testId: PropTypes.string.isRequired,
};
